module.exports = __webpack_public_path__ + "img/drink_welcome_opt.6ec050cd.jpg";